import React from 'react';
import { Container, Eyebrow, H2, Reveal } from './shared';

const WEEKS = [
  { label: 'WOCHE 1', title: 'Suchen & Verstehen', text: 'Wie du gute Unternehmen überhaupt findest und ihr Geschäftsmodell in einfachen Worten erklären kannst.' },
  { label: 'WOCHE 2', title: 'Qualität', text: 'Bilanz, Gewinne, Cashflow: Woran du erkennst, ob ein Unternehmen wirklich stark ist oder nur gut klingt.' },
  { label: 'WOCHE 3', title: 'Preis & Szenarien', text: 'Was ist die Aktie wert? Mit meinem einsteigerfreundlichen DCF-Modell rechnest du gute und schlechte Szenarien durch.' },
  { label: 'WOCHE 4', title: 'Chart & Umsetzung', text: 'Den richtigen Einstieg finden und deine erste eigene Analyse von A bis Z durchziehen. Ich bin live dabei.' },
];

export const Method = () => (
  <section id="methode" className="scroll-mt-20 bg-paper py-20 sm:py-28" data-testid="method-section">
    <Container>
      <Reveal className="grid gap-6 lg:grid-cols-2 lg:items-end lg:gap-16">
        <div>
          <Eyebrow>Die Methode</Eyebrow>
          <H2>Nach 4 Wochen bewertest du eine Aktie selbst. Mit System.</H2>
        </div>
        <p className="text-base leading-relaxed text-ink sm:text-lg">
          Mein 4-Phasen-System: dieselbe Struktur, die ich für jede meiner eigenen Analysen nutze. Pro Woche eine Phase, drei Live-Calls.
        </p>
      </Reveal>
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {WEEKS.map((w, i) => (
          <Reveal key={w.label} delay={i * 80}>
            <article className="flex h-full flex-col rounded-[24px] border border-line bg-navy p-6 sm:p-7" data-testid={`method-card-${i + 1}`}>
              <p className="text-xs font-bold tracking-[0.16em] text-mint">{w.label}</p>
              <span className="mt-6 font-display text-5xl font-extrabold text-white/10" aria-hidden="true">0{i + 1}</span>
              <h3 className="mt-2 font-display text-xl font-bold text-white">{w.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-white/70">{w.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </Container>
  </section>
);
